import React, { useEffect, useState } from 'react';
import { ButtonV2 } from '@withjoy/joykit';
import { useTranslation } from '@shared/core';
import { FixedActionButtonContainer, ActionBarTransition } from '../ActionBar';

type GuestIdentificationStickyButtonProps = Readonly<{
  onClick: () => void;
}>;

export const GuestIdentificationStickyButton: React.FC<GuestIdentificationStickyButtonProps> = ({ onClick }) => {
  const { tq } = useTranslation('guestUnlock');

  // Flip to true on mount so the entrance animation plays. The component is
  // conditionally mounted by the provider, so it always starts hidden.
  const [show, setShow] = useState(false);
  useEffect(() => setShow(true), []);

  return (
    // `sticky` (1100) keeps the CTA below the RSVP ActionBar's `banner` (1200),
    // which renders earlier in the provider tree, so it never overlays it.
    <ActionBarTransition
      show={show}
      zIndex="sticky"
    >
      <FixedActionButtonContainer
        as="div"
        alignment="center"
        cursor="default"
      >
        <ButtonV2
          shape="rounded"
          intent="neutral"
          height={8}
          onClick={onClick}
        >
          {tq`Find your invitation`}
        </ButtonV2>
      </FixedActionButtonContainer>
    </ActionBarTransition>
  );
};
